export default __webpack_public_path__ + "media/images/tenant/banner_2-3e6b370f874d2e90f2f68683d8aacba9.png";